/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Progress_LabelInputs */

const es_co2_signup_progress_label = /** @type {(inputs: Signup_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progreso`)
};

/**

* @param {Signup_Progress_LabelInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_progress_label = /** @type {((inputs?: Signup_Progress_LabelInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Progress_LabelInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_progress_label(inputs)
});